import axios from '../utils/axios';

/**
 * Fire-and-forget nudge tracking. Emits a Klaviyo event when a service nudge is
 * shown or its CTA is clicked. Failures are swallowed so tracking never blocks the UI.
 *
 * @param {{ feature: 'resum_ai'|'auto_apply'|'job_tracker_ai', event: 'shown'|'cta_clicked' }} payload
 */
const trackNudge = ({ feature, event }) => {
	return axios.post('/api/nudges/track', { feature, event }).catch(() => {});
};

export { trackNudge };
